export type WrapperType = 'WEB' | 'iOS';

export interface ProviderEventHandlers {
  providerEventHandler: (event: MessageEvent) => void;
  wrapperEventHandler: (event: MessageEvent) => void;
}

export interface BaseWrapperEvent {
  source: WrapperType;
  type: string;
}

export const WRAPPER_TO_PROVIDER_EVENT_TYPES = {
  TOGGLE_AUDIO: 'GL/TOGGLE_AUDIO',
  RELOAD_BALANCE: 'GL/RELOAD_BALANCE',
  DISMISS_ERROR: 'GL/DISMISS_ERROR',
  TOGGLE_PAYTABLE: 'GL/TOGGLE_PAYTABLE',
  TOGGLE_HELP: 'GL/TOGGLE_HELP',
  FREE_SPINS_DIALOG: 'GL/FREE_SPINS_DIALOG',
  AUTO_SPIN_STOP: 'GL/AUTO_SPIN_STOP',
  AUTO_SPIN_RESUME: 'GL/AUTO_SPIN_RESUME',
  FORCE_END_SESSION: 'GL/LAUNCHER_FORCE_END_SESSION',
} as const;

export type WrapperToProviderEventType =
  (typeof WRAPPER_TO_PROVIDER_EVENT_TYPES)[keyof typeof WRAPPER_TO_PROVIDER_EVENT_TYPES];

interface ToggleAudio extends BaseWrapperEvent {
  type: typeof WRAPPER_TO_PROVIDER_EVENT_TYPES.TOGGLE_AUDIO;
  payload: boolean;
}

interface ReloadBalance extends BaseWrapperEvent {
  type: typeof WRAPPER_TO_PROVIDER_EVENT_TYPES.RELOAD_BALANCE;
  payload: string;
}

interface DismissError extends BaseWrapperEvent {
  type: typeof WRAPPER_TO_PROVIDER_EVENT_TYPES.DISMISS_ERROR;
}

interface TogglePaytable extends BaseWrapperEvent {
  type: typeof WRAPPER_TO_PROVIDER_EVENT_TYPES.TOGGLE_PAYTABLE;
}

interface ToggleHelp extends BaseWrapperEvent {
  type: typeof WRAPPER_TO_PROVIDER_EVENT_TYPES.TOGGLE_HELP;
}

interface ChooseDialog extends BaseWrapperEvent {
  type: typeof WRAPPER_TO_PROVIDER_EVENT_TYPES.FREE_SPINS_DIALOG;
  payload: number;
}

interface AutoSpinStop extends BaseWrapperEvent {
  type: typeof WRAPPER_TO_PROVIDER_EVENT_TYPES.AUTO_SPIN_STOP;
}

interface AutoSpinResume extends BaseWrapperEvent {
  type: typeof WRAPPER_TO_PROVIDER_EVENT_TYPES.AUTO_SPIN_RESUME;
}

interface ForceEndSession extends BaseWrapperEvent {
  type: typeof WRAPPER_TO_PROVIDER_EVENT_TYPES.FORCE_END_SESSION;
}

export type WrapperToProviderEvent =
  | ToggleAudio
  | ReloadBalance
  | DismissError
  | TogglePaytable
  | ToggleHelp
  | ChooseDialog
  | AutoSpinStop
  | AutoSpinResume
  | ForceEndSession;

export function isWrapperToProviderEvent(
  type: WrapperToProviderEventType,
): boolean {
  return Object.values(WRAPPER_TO_PROVIDER_EVENT_TYPES).includes(type);
}
